<template>
  <!-- 目标路由页面 -->
  <router-view />
  <!-- 开屏广告弹窗（层级在页面之上） -->
  <HomeSplashAd 
    v-if="showSplashAd" 
    @close="handleAdClose"
  />
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import HomeSplashAd from '@/components/Home-SplashAd.vue';

// 1. 从 localStorage 读取是否已显示过广告（持久化标记）
const hasShownSplashAd = localStorage.getItem('hasShownSplashAd');
const showSplashAd = ref(false);

// 2. 页面挂载后，确保路由页面加载完成再显示广告
onMounted(async () => {
    window.addEventListener('unhandledrejection', (event) => {
    event.preventDefault(); // 阻止控制台报错提示
    const error = event.reason;
    console.log('===== 出错详情 =====');
    console.log('错误原因:', error.message);
    // 打印完整堆栈（包含业务文件路径）
    console.log('完整堆栈:', error.stack);
  });
  // 仅当未显示过广告时，才触发弹窗
  if (!hasShownSplashAd) {
    // nextTick 确保路由页面已渲染完成
    await nextTick();
    showSplashAd.value = true;
  }
});

// 3. 关闭广告时，标记为已显示（持久化到 localStorage）
const handleAdClose = () => {
  showSplashAd.value = false;
  localStorage.setItem('hasShownSplashAd', 'true');
};
</script>

<style>
/* 全局样式：防止页面滚动穿透 */
body {
  margin: 0;
  padding: 0;
  overflow: hidden; /* 临时禁止页面滚动，避免穿透 */
}
/* 广告关闭后恢复滚动 */
body.ad-closed {
  overflow: auto;
}
</style>